import { Box, Center, Icon } from '@chakra-ui/react';
import SvgArsEmptyReport from '@/pages/reports/ats-reports/components/empty-report/Icon';
import { KText } from '@/ui-library/components';

export const EmptyReportChart = ({
  text = 'Nothing found',
  subText = ' Sorry but it looks like there’s no data available for the time or filter you indicated. Please try readjusting.',
}) => {
  return (
    <Box height="100%" width="100%">
      <Center
        flexDirection="column"
        minHeight="400px"
        height="100%"
        width="100%"
        margin="0 auto"
        alignItems="center"
      >
        <Icon as={SvgArsEmptyReport} w="fit-content" h="fit-content" />
        <KText fontWeight="semiBold" fontSize={{ base: '14px', md: '16px' }}>
          {text}
        </KText>
        <KText
          fontWeight={400}
          fontSize={{ base: '10px', md: '12px' }}
          textAlign="center"
        >
          {subText}
        </KText>
      </Center>
    </Box>
  );
};
